angular.module('eStories.navbars', [
    /*Top Navbar Module*/
    'eStories.registration.model',
    'eStories.purchase',
    'eStories.purchase.update',
    'eStories.purchase.confirm',
    'eStories.purchase.choose',
    'eStories.player',
    'eStories.account.model'
])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('eStories.navbars', {
                url: '/',
                views: {
                    'topNavbar@': {
                        controller: 'NavbarsCtrl as navbarsCtrl',
                        templateUrl: 'navbars/topNavbar.tmpl.html'
                    },
                    'searchBar@': {
                        controller: 'AutocompleteCtrl as autocompleteCtrl',
                        templateUrl: 'search/autocomplete.tmpl.html'
                    },
                    'promoBar@': {
                        controller: 'PromoCtrl as promoCtrl',
                        templateUrl: 'home/promo/promoBar.tmpl.html'
                    },
                    'notifications@': {
                        controller: 'NotificationsCtrl as notificationsCtrl',
                        templateUrl: 'notifications/notifications.tmpl.html'
                    },
                    'mainView@': {
                        controller: 'HomeCtrl as homeCtrl',
                        templateUrl: 'home/home.tmpl.html'
                    },
                    'footer@': {
                        templateUrl: 'home/footer.tmpl.html'
                    },
                    'gdpr@': {
                        controller: 'PrivacyCenterCtrl as privacyCenterCtrl',
                        templateUrl: 'home/gdprBanner.tmpl.html'

                    },
                    'modals@': {
                        templateUrl: 'modals/modals.tmpl.html'
                    },
                    'player@': {
                        templateUrl: 'player/player.tmpl.html',
                        controller: 'PlayerCtrl as playerCtrl'
                    }
                }
            });
    }])

    .controller('NavbarsCtrl', [
        '$rootScope',
        'ModalsModel',
        'AccountModel',
        'UploadModel',
        'LL',
        '$aria',
        'CatalogModel',
        'PagingModel',
        function ($rootScope,
                  ModalsModel,
                  AccountModel,
                  UploadModel,
                  LL,
                  $aria,
                  CatalogModel,
                  PagingModel) {

            let navbarsCtrl = this;

            navbarsCtrl.uploadModel = UploadModel;
            navbarsCtrl.showAccountDropDown = false;

            navbarsCtrl.showNavSignUpModal = function () {
                AccountModel.signUpOrConfirmTrial();
                /*AccountModel.resetPlanPurchaseProperties();
                 AccountModel.showSignUp();*/
            };

            navbarsCtrl.openUploadModal = function () {
                LL.tagEvent("Upload Select");
                ModalsModel.open('/uploader/uploadModal.tmpl.html', 'UploadCtrl', 'uploadCtrl')
            };

            navbarsCtrl.account = AccountModel;

            navbarsCtrl.openModal = function (modalId, controller, controllerAs) {
                ModalsModel.open(modalId, controller, controllerAs);
            };

            /*Sends broadcast to autocompleteCtrl to show searchBar*/
            navbarsCtrl.showSearchbar = function () {
                navbarsCtrl.hideSearchIcon = true;
                $rootScope.$broadcast('showSearchbar');
            };

            /*Listener to event coming from searchBar to toggle navbar states*/
            $rootScope.$on('hideSearchbar', function (event) {
                navbarsCtrl.hideSearchIcon = false;
            });

            $rootScope.$on('successfulSignOut', function (event) {
                navbarsCtrl.showAccountDropDown = false;
            });
            $rootScope.$on('successfulSignIn', function (event) {
                navbarsCtrl.showAccountDropDown = false;
            });

            /*TODO: Calls for discover dropdown  add caching to this if in home.js*/

            this.getDailyDeal = async () => {
                const res = await CatalogModel.getSectionByName('DAILY_DEAL');
                if (res && res['responseStatus'] === 'SUCCESS') {
                    const getSectionItemListObj = {
                        sectionId: res['section']['id'],
                        pagination: PagingModel.preparePagination(1, 12, null, null, null)
                    };
                    const section = await CatalogModel.getSectionItemList(getSectionItemListObj);
                    if (section && section['responseStatus'] === 'SUCCESS') {
                        CatalogModel.dailyDeal = section['sectionItemList'][0];
                    }
                }
            };

            this.getDailyDeal();

            $rootScope.$broadcast('navbarsCtrlLoaded');

        }]);


